import type { AssessmentRepository } from '../../data/repositories/AssessmentRepository.js';
import type { AssessmentEntity, AssessmentResponseEntity } from '../entities/AssessmentEntity.js';

export function createListAssessmentsUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (projectId: string) => assessmentRepository.list(projectId);
}

export function createGetAssessmentByIdUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (id: string) => assessmentRepository.getById(id);
}

export function createCreateAssessmentUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (entity: Partial<AssessmentEntity>) => assessmentRepository.create(entity);
}

export function createUpdateAssessmentUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (id: string, patch: Partial<AssessmentEntity>) => assessmentRepository.update(id, patch);
}

export function createPublishAssessmentUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (id: string) =>
    assessmentRepository.update(id, {
      status: 'published',
      publishedAt: new Date().toISOString(),
    });
}

export function createDeleteAssessmentUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (id: string) => assessmentRepository.delete(id);
}

export function createListAssessmentResponsesUseCase({
  assessmentRepository,
}: {
  assessmentRepository: AssessmentRepository;
}) {
  return (assessmentId: string) => assessmentRepository.listResponses(assessmentId);
}
